import { useCurrentUser, useToastProvider } from "@qualio/ui-components";
import { useMutation, useQueryClient } from "react-query";
import { designControlsApi } from "../../api/designControls";
import { Product } from "@design-controls/types";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export const useUpdateProduct = () => {
  const { t } = useTranslation();
  const { companyId } = useCurrentUser();
  const navigate = useNavigate();
  const { showToast } = useToastProvider();
  const client = useQueryClient();

  return useMutation({
    mutationFn: (product: Product) =>
      designControlsApi.updateProduct(companyId, product),
    onSuccess: async (_: unknown, product: Product) => {
      showToast({
        title: t("products.notifications.updateSuccess.title"),
        description: t("products.notifications.updateSuccess.description"),
        status: "success",
        "data-cy": "toast-product-update-success",
      });
      await client.invalidateQueries(["PRODUCT", companyId, product.id]);
      navigate("..");
    },
    onError: () =>
      showToast({
        title: t("products.notifications.updateError.title"),
        description: t("products.notifications.updateError.description"),
        status: "error",
        "data-cy": "toast-product-update-error",
      }),
  });
};
